<div class="drop-down-container" (clickOutsideDdown)="showItems = false">
    <div class="field-container left white" (clickOutsideDdown)="onBlur()">
        <input class="field-container__input" [id]="'searchInput-'+id" type="text" (keydown)="onKeyDown($event)"
            [placeholder]="placeholder" (focus)="onFocus()" [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchQuery($event)" (click)="showItems = true">
        <span class="btn btn__clean icon-container" *ngIf="!focus && !loadingSearch" (click)="onButtonClick($event)">
            <i *ngIf="!loadingSearch" class="icon icon-search"></i>
            <i *ngIf="loadingSearch" class="icon loader"></i>
        </span>
        <div class="btn btn__clean icon-container" *ngIf="focus && !loadingSearch && searchQuery.length > 0" (click)="onCleanSearch()">
            <i *ngIf="loadingSearch" class="icon loader"></i>
            <i *ngIf="!loadingSearch" class="icon icon-close"></i>
        </div>
        <div class="btn btn__clean icon-container" *ngIf="loadingSearch">
            <i class="icon loader"></i>
        </div>
    </div>
    <ul class="options-container" [ngClass]="{'open': showItems && items.length > 0}">
        <li class="option" *ngFor="let item of items" (click)="onItemSelected(item)">
            @if(icon){ <i class="icon" [ngClass]="icon"></i> }
            <span>{{ item?.name }}</span>   
        </li>
    </ul>
</div>
